import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import { FaFilePdf } from "react-icons/fa";
import { getAllData } from "../../../Utils/firebaseServices";
import LoadingCircular from "../../../loader/LoadingCircular";

const UserPortalData = () => {
  const [userPortalData, setuserPortalData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedExperience, setSelectedExperience] = useState([]);
  const [selectedEducation, setSelectedEducation] = useState({});
  const [showEducationModal, setShowEducationModal] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await getAllData("userPortalData", setuserPortalData);
      } catch (error) {
        console.error("Error fetching data", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleShowModal = (experience) => {
    setSelectedExperience(experience);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedExperience([]);
  };

  const handleShowEducationModal = (education) => {
    setSelectedEducation(education);
    setShowEducationModal(true);
  };

  const handleCloseEducationModal = () => {
    setShowEducationModal(false);
    setSelectedEducation({});
  };

  const renderDocumentLinks = (links) => {
    if (!links || links.length === 0) return "N/A";
    return links.map((link, idx) => (
      <a
        key={idx}
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        style={{ marginRight: 8 }}
      >
        <FaFilePdf style={{ minHeight: 24, minWidth: 24 }} />
      </a>
    ));
  };

  const renderExperienceButton = (experience) => {
    if (!experience || experience.length === 0) return "N/A";
    return (
      <Button
        variant="primary"
        size="sm"
        style={{
          backgroundColor: "black",
          boxShadow: "none",
          "&:hover": {
            backgroundColor: "black",
          },
          border: "none",
        }}
        onClick={() => handleShowModal(experience)}
      >
        View More
      </Button>
    );
  };

  const renderEducationButton = (education) => {
    if (!education || Object.keys(education).length === 0) return "N/A";
    return (
      <Button
        variant="primary"
        size="sm"
        style={{
          backgroundColor: "black",
          boxShadow: "none",
          "&:hover": {
            backgroundColor: "black",
          },
          border: "none",
        }}
        onClick={() => handleShowEducationModal(education)}
      >
        View More
      </Button>
    );
  };

  if (loading) {
    return <LoadingCircular />;
  }

  return (
    <div style={{ width: "100%", overflowX: "auto" }}>
      <Table bordered responsive>
        <thead>
          <tr>
            <th style={headerStyle}>Sr.n.</th>
            <th style={headerStyle}>Name</th>
            <th style={headerStyle}>Mobile No</th>
            <th style={headerStyle}>DOB</th>
            <th style={headerStyle}>Father's Name</th>
            <th style={headerStyle}>Mother's Name</th>
            <th style={headerStyle}>Gender</th>
            <th style={headerStyle}>Educational Docs</th>
            <th style={headerStyle}>Experience</th>
          </tr>
        </thead>
        <tbody>
          {userPortalData.length === 0 ? (
            <tr>
              <td colSpan={10} style={{ textAlign: "center" }}>
                No data available
              </td>
            </tr>
          ) : (
            userPortalData.map((item, index) => (
              <tr key={index}>
                <td style={{ textAlign: "center" }}>{index + 1}</td>
                <td>{item.name || "N/A"}</td>
                <td>{item.mobilno || "N/A"}</td>
                <td>{item.dob || "N/A"}</td>
                <td>{item.fatherName || "N/A"}</td>
                <td>{item.motherName || "N/A"}</td>
                <td>{item.gender || "N/A"}</td>
                <td style={{ textAlign: "center" }}>
                  {renderEducationButton(item.Educational)}
                </td>
                <td style={{ textAlign: "center" }}>
                  {renderExperienceButton(item.Experience)}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        size="lg"
        dialogClassName="custom-modal-size"
      >
        <Modal.Header closeButton>
          <Modal.Title>Experience Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedExperience.length === 0 ? (
            <p>No Experience Data</p>
          ) : (
            <div>
              {selectedExperience.map((exp, idx) => (
                <div key={idx} style={{ marginBottom: "30px" }}>
                  <p>
                    <strong>Company:</strong> {exp.comp_name || "N/A"}
                    <br />
                    <strong>Experience:</strong> {exp.Exp_years || "N/A"}{" "}
                    year(s)
                    <br />
                    <strong>Joining Date:</strong> {exp.doj || "N/A"}
                    <br />
                    <strong>End Date:</strong> {exp.doe || "N/A"}
                  </p>
                  <table style={{ width: "100%", fontSize: 14 }} border="1">
                    <thead>
                      <tr>
                        <th>Document Type</th>
                        <th>Document(s)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Offer Letter</td>
                        <td>{renderDocumentLinks(exp.doc_offerLetter)}</td>
                      </tr>
                      <tr>
                        <td>Relieving Letter</td>
                        <td>{renderDocumentLinks(exp.doc_relievingLetter)}</td>
                      </tr>
                      <tr>
                        <td>Experience Letter</td>
                        <td>{renderDocumentLinks(exp.doc_experienceLetter)}</td>
                      </tr>
                      <tr>
                        <td>Salary Slip</td>
                        <td>{renderDocumentLinks(exp.doc_salarySlip)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ))}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            style={{
              backgroundColor: "black",
              boxShadow: "none",
              border: "none",
            }}
            onClick={handleCloseModal}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showEducationModal}
        onHide={handleCloseEducationModal}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Educational Documents</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedEducation && Object.keys(selectedEducation).length > 0 ? (
            <table style={{ width: "100%", fontSize: 14 }} border="1">
              <thead>
                <tr>
                  <th>Degree / Qualification</th>
                  <th>Documents</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(selectedEducation).map(([key, links], idx) => (
                  <tr key={idx}>
                    <td>
                      <strong>{key}</strong>
                    </td>
                    <td>{renderDocumentLinks(links)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No Documents Available</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            style={{
              backgroundColor: "black",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: "black",
              },
              border: "none",
            }}
            onClick={handleCloseEducationModal}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

const headerStyle = {
  backgroundColor: "black",
  color: "white",
  textAlign: "center",
};

export default UserPortalData;
